import {
  ApiOutlined,
  DollarCircleOutlined,
  NodeIndexOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { Layout } from '@surecompanies/core_components'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import { usePermission } from 'enrollment-platform/rbac/usePermission'
import Page from 'layouts/Page'
import React from 'react'
import { Link } from 'react-router'
import PageWrapper from '../../../PageWrapper'
import BreadcrumbNav from '../../../components/Breadcrumbs'

const { Content } = Layout

export default function Landing({ router }: { router: any }) {
  // Census is US-restricted data: hide the menu entry unless allowed. While the
  // ability is loading, `allowed` is false so the link never flashes in.
  const { allowed: hasUsRestrictedAccess, isLoading } = usePermission(
    RbacActions.Manage,
    RbacSubjects.UsRestrictedData
  )
  const allowed = hasUsRestrictedAccess && !isLoading

  return (
    <PageWrapper>
      <Page
        title="HRIS"
        breadcrumb={<BreadcrumbNav items={[{ title: 'HRIS' }]} />}
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              padding: '24px',
            }}
          >
            {allowed ? (
              <Link to={`${router.location.pathname}/census`}>
                <TeamOutlined style={{ marginRight: '8px' }} />
                Census
              </Link>
            ) : null}
            <Link to={`${router.location.pathname}/payroll`}>
              <DollarCircleOutlined style={{ marginRight: '8px' }} />
              Payroll
            </Link>
            <Link to={`${router.location.pathname}/api-visibility`}>
              <ApiOutlined style={{ marginRight: '8px' }} />
              API Visibility
            </Link>
            <Link to={`${router.location.pathname}/census-visibility-plumbing`}>
              <NodeIndexOutlined style={{ marginRight: '8px' }} />
              Census Visibility Plumbing
            </Link>
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}
